import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/AdvertisementBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/cards/HorizontalArticleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/RecommendedNews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/author/AuthorArticlesListSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/author/AuthorInterviewsListSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/author/AuthorNewsListSection.tsx");
